import React from 'react';
import qs from 'qs';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import Link from 'Components/Link';

import ReactGA from 'react-ga';
import * as usersActions from '../store/users/actions';
import * as reducers from '../store/reducers';

import ContentFrame from 'Components/ContentFrame';
import Form from 'Components/Form';
import Loading from 'Components/Loading';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import FormNote from 'Components/FormNote';
import SectionHeader from 'Components/SectionHeader';
import { ROUTES } from 'Settings/route-strings';

import img1 from 'Static/images/free-access-trial/appillustrations-1.png';
import img2 from 'Static/images/free-access-trial/appillustrations-2.png';

class FreeTrialOnlineLearning extends React.Component {
  constructor(props) {
    super(props);
    this.licenseMap = {
      school: 'SELF_SERVICE_TRIAL_SCHOOL',
      homeschool: 'SELF_SERVICE_TRIAL_HOMESCHOOL',
      classroom: 'SELF_SERVICE_TRIAL_CLASSROOM',
    };
  }

  render() {
    const { activeUser, tokenIsActive, location, source } = this.props;
    if (activeUser) return <Redirect to={ROUTES.EXPLORE} />;
    if (tokenIsActive) return <Loading />;
    const licenseType =
      location.state && location.state.licenseType
        ? location.state.licenseType
        : 'homeschool';

    const initialFieldSettings = {
      licenseType: {
        value: this.licenseMap[licenseType] || this.licenseMap.school,
      },
    };

    if (source) initialFieldSettings.source = { value: source };

    return (
      <main className="Page__content">
        <ContentFrame pageType="transactional" size="medium">
          <SectionHeader title="Free One Month Trial" />
          <div>
            <div>
              <p>
                We know that parents and teachers are looking for high quality
                services to support online learning during this crisis.
                We&lsquo;re here to help.
              </p>
              <p>
                <ConnectedFormattedMessage
                  id="free_trial_page.selected_plan"
                  values={{
                    license_name: (
                      <strong>
                        <ConnectedFormattedMessage
                          id={`pricing_plan.${licenseType}.title`}
                        />
                      </strong>
                    ),
                  }}
                />{' '}
                <Link to={ROUTES.PRICING} className="u-text-link">
                  <ConnectedFormattedMessage id="free_trial_online_learning_page.change_plans_link" />
                </Link>
                .
              </p>
              <p>
                Questions? Email{' '}
                <a href="mailto:schools@tinybop.com" className="u-text-link">
                  schools@tinybop.com
                </a>
                .
              </p>
            </div>

            <div
              style={{
                display: 'flex',
                marginBottom: '2em',
                marginTop: '2em',
                alignItems: 'center',
              }}
            >
              <img
                alt=""
                style={{ height: '100%', width: '48%', marginRight: '4%' }}
                src={img1}
              />
              <img alt="" style={{ height: '100%', width: '48%' }} src={img2} />
            </div>
          </div>
          <Form
            type="freeTrial"
            id="freeTrial"
            formStyle="acceptTeacherInvitation"
            messagePosition="fixed-top"
            initialFieldSettings={initialFieldSettings}
            submitButtonType="primary"
            formNote={
              <FormNote
                text={
                  <strong>
                    <ConnectedFormattedMessage
                      id="form.note.freeTrial.text"
                      values={{
                        sign_in_link: (
                          <Link to={ROUTES.SIGN_IN} className="u-text-link">
                            <ConnectedFormattedMessage id="form.note.freeTrial.sign_in_link" />
                          </Link>
                        ),
                      }}
                    />
                  </strong>
                }
              />
            }
          />
        </ContentFrame>
      </main>
    );
  }
}

const mapStateToProps = (state, { location, match: { params } }) => {
  const queryObj = qs.parse(location.search, { ignoreQueryPrefix: true });
  const source = queryObj.source || params.source;

  return {
    activeUser: reducers.getActiveUser(state),
    tokenIsActive: state.users.auth.token !== null,
    source,
  };
};

export default withRouter(
  connect(mapStateToProps, usersActions)(FreeTrialOnlineLearning)
);
